// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1x7-w","loaderOuter":"PageOverlayLoader_loaderOuter__3c_-T"};